// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"BlueButton_buttonWrapper__Ya505","buttonText":"BlueButton_buttonText__kSDdf"};